export enum DIRECTION_TYPE {
  TO_SITE = 'to site',
  FROM_SITE = 'from site',
  TO_PROVIDER = 'to provider',
  TO_OTHER_LOCATION = 'to other location',
}

export const DIRECTIONS = [
  { label: 'Shipping to work order location', value: DIRECTION_TYPE.TO_SITE },
  { label: 'Shipping to provider', value: DIRECTION_TYPE.TO_PROVIDER },
  { label: 'Ship to pre-site pickup', value: DIRECTION_TYPE.TO_OTHER_LOCATION },
  { label: 'Ship from site or return to carrier location', value: DIRECTION_TYPE.FROM_SITE },
];

export const DIRECTIONS_FOR_PROVIDERS = [
  { label: 'Shipping to work order location', value: DIRECTION_TYPE.TO_SITE },
  { label: 'Ship from site or return to carrier location', value: DIRECTION_TYPE.FROM_SITE },
];

export const DIRECTIONS_WITHOUT_OTHER_LOCATION = [
  { label: 'Shipping to work order location', value: DIRECTION_TYPE.TO_SITE },
  { label: 'Shipping to provider', value: DIRECTION_TYPE.TO_PROVIDER },
  { label: 'Ship from site or return to carrier location', value: DIRECTION_TYPE.FROM_SITE },
];

export enum CARRIER_TYPE {
  UPS = 'ups',
  FEDEX = 'fedex',
  USPS = 'usps',
  OTHER = 'other',
}

export const CARRIERS = [
  {
    value: CARRIER_TYPE.UPS,
    label: 'UPS',
    url: 'http://wwwapps.ups.com/WebTracking/track?track=yes&trackNums={trackingNumber}',
    regs: [
      /^1Z[A-Z0-9]{16}$|^[0-9]{9}$|^[0-9]{26}$|^T[0-9A-Z]{10}$/,
    ],
  },
  {
    value: CARRIER_TYPE.FEDEX,
    label: 'FedEx',
    url: 'https://www.fedex.com/apps/fedextrack/?tracknumbers={trackingNumber}',
    regs: [
      /^(?:DT[0-9]{12}|[0-9]{12}|[0-9]{14,15}|[0-9]{20,22}|96[0-9]{20}|[A-Z0-9]{17})$/,
    ],
  },
  {
    value: CARRIER_TYPE.USPS,
    label: 'USPS',
    url: 'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1={trackingNumber}',
    regs: [
      /^(?:94|93|92|95|70|14|23|03|M0|82)[0-9]{10,20}$|^[A-Z]{2}[0-9]{9}[A-Z]{2}$/,
    ],
  },
  {
    value: CARRIER_TYPE.OTHER,
    label: 'Other',
  },
];
